import React, {FC, useMemo} from 'react';

import classNames from 'classnames';
import {connect} from 'react-redux';

import {useFeatureWithAnalytics} from 'components/feature';
import {Price} from 'components/price/price';
import {getCurrentBenefitsBrand} from 'desktop/pages/checkout/store/selectors/orderReviewTotals/utils/getCurrentBenefitsBrand';
import {ApplicationStoreType} from 'desktop/store';
import {isUhcEnabled} from 'libs/rollout';

import {DiscountLabelConnected} from './discountLabel/discountLabel';

import {DiscountLabelV2Connected} from './discountLabelV2/discountLabelV2';

import s from './cartSummaryDiscount.scss';

export type PropsType = {
    discount: string;
    coupons: Array<string>;
};

/**
 * Displays all applied coupons and their discount, and uhc allowance if it is uhc user
 * @params {PropsType} props - component props
 * @return {ReactElement} component
 */
export const CartSummaryDiscount: FC<PropsType> = ({coupons, discount}) => {
    const isDiscountColor = useFeatureWithAnalytics('dCartUI_discountColor', false, 'desktop');

    const renderingDiscountLabel = useMemo(
        () => (isDiscountColor ? <DiscountLabelV2Connected /> : <DiscountLabelConnected />),
        [isDiscountColor],
    );

    const label = isUhcEnabled() ? (
        <div className={isDiscountColor ? s.UHCUnderDiscountFlag : ''}>
            {getCurrentBenefitsBrand().brandName} Plan Benefits
        </div>
    ) : (
        renderingDiscountLabel
    );

    const couponsSummary = (
        <div className={s.wrapper}>
            {label}
            {Number(discount) > 0 && (
                <div
                    className={classNames({[s.priceUnderDiscountFlag]: isDiscountColor})}
                    id="summary_discount"
                >
                    -<Price>{discount}</Price>
                </div>
            )}
        </div>
    );

    if (isUhcEnabled() && Number(discount) > 0) return couponsSummary;

    return coupons?.length ? couponsSummary : null;
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    coupons: store.cart.totals.appliedCoupons,
    discount: store.cart.totals.discount,
});

export const CartSummaryDiscountConnected = connect(mapStateToProps)(CartSummaryDiscount);
